import { render, staticRenderFns } from "./edit3.vue?vue&type=template&id=2436a0fc&scoped=true"
import script from "./edit3.vue?vue&type=script&lang=js"
export * from "./edit3.vue?vue&type=script&lang=js"
import style0 from "./edit3.vue?vue&type=style&index=0&id=2436a0fc&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436a0fc",
  null
  
)

export default component.exports